import React, { useState, useEffect } from 'react';
import Select from "react-select";
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';
import { autoCompleteGestoras, autoCompleteUnidades } from "../../../../../components/utils/autocompletes";

import { FaRegSave, FaTimes } from 'react-icons/fa';

const CentroDeCustoModal = ({ centroDeCusto, onClose, onCentroDeCustoAtualizado }) => {
    const [formData, setFormData] = useState({
        nome: '',
        abrangencia: 'gestora',
        gestora_id: '',
        unidade_id: '',
        ativo: true
    });
    const [tituloModal, setTituloModal] = useState("");
    
    const { inputPesquisaGestora, gestorasOptions, handleAutoCompleteGestoras, handleFocusGestoras } = autoCompleteGestoras();
    const { inputPesquisaUnidade, unidadesOptions, handleAutoCompleteUnidades, handleFocusUnidades } = autoCompleteUnidades();

    const customStyles = {
        menu: (provided) => ({
            ...provided,
            whiteSpace: "pre-line",
        }),
        option: (provided) => ({
            ...provided,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
        }),
    };

    useEffect(() => {
        if (centroDeCusto != null) {
            setFormData({
                nome: centroDeCusto.nome || '',
                abrangencia: centroDeCusto.abrangencia || 'gestora',
                gestora_id: centroDeCusto.gestora && centroDeCusto.gestora.id && centroDeCusto.gestora.nome ? 
                    { value: centroDeCusto.gestora.id, label: centroDeCusto.gestora.nome } : '',
                unidade_id: centroDeCusto.unidade && centroDeCusto.unidade.id && centroDeCusto.unidade.nome ? 
                    { value: centroDeCusto.unidade.id, label: centroDeCusto.unidade.nome } : '',
                ativo: centroDeCusto.ativo !== undefined ? centroDeCusto.ativo : true
            });
            setTituloModal('Editar Centro de Custo');
        } else {
            setTituloModal('Novo Centro de Custo');
        }
    }, [centroDeCusto]);

    useEffect(() => {
        if (!formData.gestora_id && formData.unidade_id) {
            setFormData(prev => ({
                ...prev,
                unidade_id: ''
            }));
        }
    }, [formData.gestora_id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        let finalValue = value;
        
        if (name === 'ativo') {
            finalValue = value === 'true';
        } else if (type === 'checkbox') {
            finalValue = checked;
        }
        
        setFormData(prev => ({
            ...prev,
            [name]: finalValue
        }));
    };

    const handleSelectChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value || ''
        }));

        if (name === 'gestora_id') {
            setFormData(prev => ({
                ...prev,
                [name]: value || '',
                unidade_id: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.nome.trim()) {
            Swal.fire('Atenção', 'O nome do centro de custo deve ser preenchido.', 'warning');
            return;
        }

        if (!formData.gestora_id || !formData.gestora_id.value) {
            Swal.fire('Atenção', 'A gestora deve ser selecionada.', 'warning');
            return;
        }

        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const dataToSend = {
                nome: formData.nome,
                abrangencia: formData.abrangencia,
                gestora_id: formData.gestora_id?.value || formData.gestora_id,
                unidade_id: formData.unidade_id?.value || null,
                ativo: formData.ativo
            };

            if (centroDeCusto) {
                await api.put(`/centros-de-custo/${centroDeCusto.id}`, dataToSend);
                Swal.fire("Sucesso", "Centro de custo atualizado com sucesso!", "success");
            } else {
                await api.post('/centros-de-custo', dataToSend);
                Swal.fire("Sucesso", "Centro de custo criado com sucesso!", "success");
            }

            onCentroDeCustoAtualizado();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', error.response.data.message || 'Erro ao salvar centro de custo.', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-8 col-12">
                                    <label className="form-label fw-bold">Nome</label>
                                    <input
                                        type="text"
                                        name="nome"
                                        className="form-control"
                                        value={formData.nome}
                                        onChange={handleChange}
                                        maxLength={255}
                                        required
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Abrangência</label>
                                    <select
                                        name="abrangencia"
                                        className="form-control"
                                        value={formData.abrangencia}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="gestora">Gestora</option>
                                        <option value="unidade">Unidade</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div className="row mt-3">
                                <div className="col-lg-6 col-12">
                                    <label className="form-label fw-bold">Gestora</label>
                                    <Select
                                        options={gestorasOptions}
                                        styles={customStyles}
                                        onInputChange={(value) => {
                                            handleAutoCompleteGestoras(value);
                                        }}
                                        onFocus={handleFocusGestoras}
                                        onChange={(value) => handleSelectChange('gestora_id', value)}
                                        placeholder="Digite o nome da gestora"
                                        isClearable
                                        menuPlacement="auto"
                                        menuPosition="fixed"
                                        noOptionsMessage={() => "Sem opções"}
                                        value={formData.gestora_id}
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                    <label className="form-label fw-bold">Unidade</label>
                                    <Select
                                        options={unidadesOptions}
                                        styles={customStyles}
                                        onInputChange={(value) => {
                                            if (formData.gestora_id?.value) {
                                                handleAutoCompleteUnidades(value, formData.gestora_id.value);
                                            }
                                        }}
                                        onFocus={() => handleFocusUnidades(formData.gestora_id?.value)}
                                        onChange={(value) => handleSelectChange('unidade_id', value)}
                                        placeholder="Digite o nome da unidade"
                                        isClearable
                                        menuPlacement="auto"
                                        menuPosition="fixed"
                                        noOptionsMessage={() =>
                                            !formData.gestora_id?.value
                                                ? "Selecione uma gestora primeiro"
                                                : "Sem opções"
                                        }
                                        value={formData.unidade_id}
                                        isDisabled={!formData.gestora_id?.value}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>

                            <div className="row mt-3">
                                <div className="col-lg-6 col-12">
                                    <label className="form-label fw-bold">Status</label>
                                    <select
                                        name="ativo"
                                        className="form-control"
                                        value={formData.ativo}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value={true}>Ativo</option>
                                        <option value={false}>Inativo</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer mt-4">
                            <div className="row">
                                <div className="col-12 text-end">
                                    <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                        <FaTimes /> Fechar
                                    </button>
                                    <button className="btn btn-custom-primary ms-3" type="submit">
                                        <FaRegSave /> Salvar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CentroDeCustoModal; 